// LICENSE_CODE ZON
'use strict';/*jslint ts:true, react: true*/
import React, {useEffect, useMemo, useContext, Fragment} from 'react';
// @ts-ignore
import {createPortal} from 'react-dom';
import cn from 'classnames';
import {Settings_context} from '../settings_ctx';
import styles from './popup.module.less';

// XXX: strategy
// top right bottom left (as margin/padding)
// auto - no fixes
// bind - connect with position
// f.e.: bind bind auto auto
export interface i_popup_props_base {
    cls?: string;
    content_when_open?: boolean;
    on_close?: ()=>void;
    anchor_element: HTMLElement;
    parent: HTMLElement;
    strategy: string;
    offset_top?: number;
    offset_top_fallback?: number;
    sync_position?: number;
    timeout?: number;
    get_offset_from_screen?: boolean;
    omit_animation?: boolean;
}
export interface i_popup_props extends i_popup_props_base {
    children: JSX.Element;
    is_open: boolean;
    on_close: ()=>void;
    on_overlay_click?: ()=>void;
    id: string;
}

const get_offset_from_screen = (el: HTMLElement, offset: boolean)=>{
    let {top, left} = offset ? {left: el.offsetLeft, top: el.offsetTop} :
        el.getBoundingClientRect();
    let scroll = el.scrollTop;
    while (el.parentElement)
    {
        el = el.parentElement;
        if (offset || el.tagName =='HTML')
            scroll += el.scrollTop;
        if (el.classList.contains('relative'))
        {
            const styles_ = window.getComputedStyle(el);
            const lb = parseInt(styles_['borderLeftWidth']) || 0;
            const tb = parseInt(styles_['borderTopWidth']) || 0;
            top += el.offsetTop + tb;
            left += el.offsetLeft + lb;
        }
        if (offset && el.tagName!='HTML')
            top -= el.scrollTop;
        if (!offset && el.tagName =='HTML')
            top += el.scrollTop;
    }
    return {top, left, scroll};
};

const apply_styles = (el: HTMLElement, anchor: HTMLElement,
    props: i_popup_props)=>
{
    const {left, top, scroll} = get_offset_from_screen(anchor,
        !props.get_offset_from_screen);
    let width = anchor.offsetWidth;
    if (!width)
        width = anchor.getBoundingClientRect().width;
    const str_array = props.strategy.split(' ');
    if (str_array[0]=='bind')
    {
        let view_port_top = top - scroll;
        let calc_top = Math.max(0, top+(props.offset_top||0));
        el.classList.remove('offcet_fallback');
        if (view_port_top + props.offset_top < 0 && props.offset_top_fallback)
        {
            el.classList.add('offcet_fallback');
            calc_top = Math.max(0, top+(props.offset_top_fallback||0));
        }
        el.style.top = `${calc_top}px`;
    }
    if (str_array[1]=='bind')
        el.style.width = `${width}px`;
    // if (str_array[2]=='bind')
    // not implemented
    if (str_array[3]=='bind')
        el.style.left = `${left}px`;
    else if (str_array[3]=='center')
    {
        const el_width = el.offsetWidth;
        let left_calc = left+width/2 - el_width/2;
        if (left_calc < 8)
            left_calc = 8;
        if (left_calc + el_width > window.outerWidth - 8)
            left_calc = window.outerWidth - 8 - el_width;
        el.style.left = `${left_calc}px`;
    }

};
export const Popup = (props:i_popup_props)=>{
    const {children, is_open, cls,
        anchor_element, sync_position, id} = props;
    const {theme} = useContext(Settings_context);
    const state = useMemo(()=>{
        if (!document.getElementById)
            return {el: null};
        const modal_root = document.getElementById('modal_root');
        if (!modal_root)
            return {el: null};
        const el = document.createElement('div');
        el.className = cn(theme.root, styles.abs_position, 'relative');
        el.style.opacity = '0';
        if (!props.omit_animation)
            el.style.marginTop = '20px';
        modal_root.appendChild(el);
        requestAnimationFrame(()=>{
            apply_styles(el, anchor_element, props);
        });
        return {el};
    }, []);
    useEffect(()=>{
        return ()=>{
            if (!state.el)
                return;
            const modal_root = document.getElementById('modal_root');
            modal_root.removeChild(state.el);
        };
    }, []);
    useEffect(()=>{
        if (!state.el)
            return;
        if (!is_open)
        {
            state.el.style.opacity = '0';
            if (!props.omit_animation)
                state.el.style.marginTop = '20px';
            state.el.style.display = 'none';
        }
        let timeout_show;
        if (is_open)
        {
            timeout_show = setTimeout(()=>{
                state.el.style.opacity = '0';
                if (!props.omit_animation)
                    state.el.style.marginTop = '20px';
                state.el.style.display = 'block';
                requestAnimationFrame(()=>{
                    apply_styles(state.el, anchor_element, props);
                    state.el.style.opacity = '1';
                    state.el.style.marginTop = '0';
                });
            }, props.timeout||0);
        }
        return ()=>{
            clearTimeout(timeout_show);
        };
    }, [is_open, state.el, sync_position]);
    const rendered = <div id={id}
      className={cn(styles.popup_window, cls)}
      onClick={event=>event.stopPropagation()}>
        <div className={styles.content}>{children}</div>
    </div>;
    if (state.el)
        return createPortal(rendered, state.el);
    return <Fragment></Fragment>;
};
